import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Private pages while the site is gated: signed-out visitors land on the Coming-Soon login screen. A temporary
// password has to be changed first. While the site is open everything works as before.
export const GateGuard = ({ children }) => {
  const { gated, user, sessionReady } = useAuth();
  const location = useLocation();
  if (!sessionReady) {
    return (
      <div data-testid="gate-checking" className="grid min-h-screen place-items-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if ((gated && !user) || user?.must_change_password) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }
  return children;
};
